import type { FilterKey } from '../../types';

import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FilterBar: FunctionComponent<Props> = ({
    activeFilter,
    className = '',
    filterKeys,
    onFilterChange,
    onSearchChange,
    searchQuery,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const labels: Record<FilterKey, string> = {
        all: t.FILTER_ALL,
        caution: t.FILTER_CAUTION,
        critical: t.FILTER_CRITICAL,
        dueSoon: t.FILTER_DUE_SOON,
        grounded: t.FILTER_GROUNDED
    };

    return (
        <HorizontalContainer className={`${styles.filterBar} ${className}`} testId={testId}>
            <HorizontalContainer className={styles.filterGroup}>
                {filterKeys.map(key => {
                    const activeClass = activeFilter === key ? styles.isActive : '';

                    return (
                        <Wrapper
                            className={`${styles.filterPill} ${activeClass}`}
                            key={key}
                            onClick={() => onFilterChange(key)}>
                            {labels[key]}
                        </Wrapper>
                    );
                })}
            </HorizontalContainer>

            <input
                className={styles.filterSearch}
                onChange={changeEvent => onSearchChange(changeEvent.target.value)}
                placeholder={t.DRONE_SEARCH_PLACEHOLDER}
                type='search'
                value={searchQuery}
            />
        </HorizontalContainer>
    );
};

export default FilterBar;
